export default __webpack_public_path__ + "static/media/circle-subm.4e8724ad.svg";